import { postRequest } from "lib/core/apiClient";

export const verifyCodOtp = async (contextId: string, otp: string, checkoutId: string, useKratosApi = false) => {
  if (!contextId || !otp) return;

  try {
    const payload = {
      context_id: contextId,
      otp: otp,
      checkout_id: checkoutId,
    };

    const url = useKratosApi
      ? `/checkout/${checkoutId}/cod-otp/verify`
      : `/checkout/v1/checkout/${checkoutId}/cod-otp/verify`;

    const response = await postRequest(url, payload, useKratosApi ? "KRATOS_PRIVATE" : "CHECKOUT");
    return response;
  } catch (e: any) {
    console.error(e);
    throw new Error(e);
  }
};

export const resentCodOtp = async (contextId: string, phone: string, checkoutId: string, useKratosApi = false) => {
  if (!contextId) return;

  try {
    const payload = {
      context_id: contextId,
      phone,
      checkout_id: checkoutId,
    };

    const url = useKratosApi
      ? `/checkout/${checkoutId}/cod-otp/resend`
      : `/checkout/v1/checkout/${checkoutId}/cod-otp/resend`;

    const response = await postRequest(url, payload, useKratosApi ? "KRATOS_PRIVATE" : "CHECKOUT");
    return response;
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
